export const STATUS_MESSAGE = {
    'OK': 'Tak for din henvendelse. Vi kontakter dig hurtigst muligt i tidsrummet man-tor: 10:00-18:00 og fre: 10:00-15:30.',
    'ERROR': 'Der opstod en fejl. Prøv venligst igen',
    'ALREADY_REGISTERED': 'Vi har allerede registreret din anmodning om at blive ringet op',
    "INVALID_PHONE": 'Vi kan ikke finde nummeret. Tjek venligst at nummeret er angivet korrekt.',
    "CLOSED": "Du har kontaktet os udenfor åbningstiden"
}